import { BaseContainerModel } from "../../base-container.model";

import { bl_fi_csg_billing_hdr_RowClass } from "../../../dbschema/bl_fi_csg_billing_hdr.model";
import { bl_fi_csg_billing_line_RowClass } from "../../../dbschema/bl_fi_csg_billing_line.model";

export class InternalConsignorPurchaseBillingContainerModel extends BaseContainerModel {
  bl_fi_csg_billing_hdr: bl_fi_csg_billing_hdr_RowClass =
    new bl_fi_csg_billing_hdr_RowClass();
  bl_fi_csg_billing_line: bl_fi_csg_billing_line_RowClass[] = [];
}
